import { IWebsiteBuilderElementStretch } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderElement";
import { WebsiteBuilderActionType } from "../../websiteBuilderAction";
import { cloneDeep } from "lodash";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderRoot";
import { elementTreeTraversal } from "../../actionHelpers/elementTreeTraversal";

export interface IUpdateElementStretchActionPayload {
  id: string;
  prevStretch: IWebsiteBuilderElementStretch;
  nextStretch: IWebsiteBuilderElementStretch;
}

export interface IUpdateElementStretchAction {
  type: typeof WebsiteBuilderActionType.UPDATE_ELEMENT_STRETCH;
  payload: IUpdateElementStretchActionPayload;
}

export function getUpdateElementStretchInverseAction(action: IUpdateElementStretchAction): IUpdateElementStretchAction {
  const { id, nextStretch, prevStretch } = action.payload;

  return {
    type: WebsiteBuilderActionType.UPDATE_ELEMENT_STRETCH,
    payload: {
      id,
      prevStretch: cloneDeep(nextStretch),
      nextStretch: cloneDeep(prevStretch),
    },
  };
}

export function applyUpdateElementStretchTreeChange(
  tree: IWebsiteBuilderRoot,
  action: IUpdateElementStretchAction,
): IWebsiteBuilderRoot {
  const { id, nextStretch } = action.payload;

  const updatedTree = elementTreeTraversal(tree, id, {
    stretch: cloneDeep(nextStretch),
  });

  return updatedTree;
}
